(ns manatee.fx.debounce
  "Source: https://github.com/day8/re-frame/discussions/693#discussioncomment-542836"
  (:require [clojure.string :as str]
            [re-frame.core :as rf]))

(defonce timeouts (atom {}))

(def clearTimeout #?(:cljs js/clearTimeout :clj (fn [& _])))

(def setTimeout #?(:cljs js/setTimeout :clj (fn [& _])))

(rf/reg-fx
 ::dispatch
 (fn [[id event-vec n]]
   (clearTimeout (@timeouts id))
   (swap! timeouts assoc id
          (setTimeout (fn []
                        (when (contains? @timeouts id)
                          (rf/dispatch event-vec)
                          (swap! timeouts dissoc id)))
                      n))))

(rf/reg-fx
 ::stop
 (fn [id-fragments]
   (let [ids (->> (keys @timeouts)
                  (filter (fn [id] (some (fn [fragm] (str/includes? id fragm)) id-fragments))))]
     (doseq [id ids]
       (clearTimeout (@timeouts id))
       (swap! timeouts dissoc id)))))
